module.exports = __webpack_public_path__ + "static/chain_icon-ba58d518416a333425a1939af1683337.svg";